import { render, staticRenderFns } from "./Room2.vue?vue&type=template&id=29417058&scoped=true&"
import script from "./Room2.vue?vue&type=script&lang=ts&"
export * from "./Room2.vue?vue&type=script&lang=ts&"
import style0 from "./Room2.vue?vue&type=style&index=0&id=29417058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29417058",
  null
  
)

export default component.exports